import { MetadataI } from "../typings/common";
import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export const url = "/v1/msttrxcode";

interface IGetTrxCodePayload {
  search: string,
  type_cashflow?: string,
  sort_by: string,
  sort_type: string,
  page_number: number,
  page_size: number,
}

export interface IGetTrxCodeData {
  trx_code: string,
  trx_desc: string,
  sap_bktxt: string,
  gnlldr: string,
  sap_shkzg: string,
  range_code: string,
  lifnr: boolean,
  kunnr: boolean,
  prctr: boolean,
  kostl: boolean,
  idtrx1: boolean,
  idtrx2: boolean,
  idtrx3: boolean,
  is_active: boolean,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string
}
interface IGetTrxCodeResponse {
  list_mst_trxcode: [],
  metadata: MetadataI,
}
interface IPostPayload {
  app_code: string,
  trx_desc: string,
  sap_bktxt: string,
  gnlldr: string,
  sap_shkzg: string,
  range_code: string,
  lifnr: boolean,
  kunnr: boolean,
  prctr: boolean,
  idtrx1: boolean,
  idtrx2: boolean,
  idtrx3: boolean,
  is_active: boolean,
  create_by: string
}
interface IPutTrxCodePayload {
  trx_code: string,
  trx_desc: string,
  sap_bktxt: string,
  gnlldr: string,
  sap_shkzg: string,
  range_code: string,
  lifnr: boolean,
  kunnr: boolean,
  prctr: boolean,
  kostl?: boolean,
  idtrx1: boolean,
  idtrx2: boolean,
  idtrx3: boolean,
  is_active: boolean,
  update_by: string
}
interface IPostResponse {
  responseCode: "Succeed" | "Failed",
  responseMessage: string
  data: string
}

export const getTrxCode = async (
  payload: IGetTrxCodePayload,
): Promise<IGetTrxCodeResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getTrxCodeDetail = async (
  trxCode: string,
): Promise<IGetTrxCodeData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/trxcode/${trxCode}/isactive/true`,
    method: "GET",
  });

  return data;
};

export const postTrxCode = async (
  payload: IPostPayload,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const putTrxCode = async (
  payload: IPutTrxCodePayload,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "PUT",
    data: payload,
  });

  return data;
};

export const deleteTrxCode = async (
  trxCode: string,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${trxCode}`,
    method: "DELETE",
  });

  return data;
};
